import { getEnvironment } from 'utilities/environment';

window.Sq = window.Sq || {};
Sq.Shop = Sq.Shop || {};
Sq.Shop.Optimizely = {
  HOSTS_BY_ENV: {
    staging: 'https://api.squareupstaging.com',
    production: 'https://api.squareup.com',
  },
  ACTIVATE_ENDPOINT: '/api/v1/xms/optimizely/proxy/activate',
  TRACK_ENDPOINT: '/api/v1/xms/optimizely/proxy/track',

  init() {
    this.getHost();
  },

  getHost() {
    const envConfig = getEnvironment();
    if (envConfig) {
      this.internal = envConfig.internal;
      this.host = this.HOSTS_BY_ENV[envConfig.env];
    } else {
      this.internal = false;
    }
  },

  activate(experimentNames) {
    this.proxyRequest(this.ACTIVATE_ENDPOINT, {
      experiment_names: experimentNames,
    });
  },

  track(eventKey) {
    this.proxyRequest(this.TRACK_ENDPOINT, { event_key: eventKey });
  },

  proxyRequest(endpoint, requestBody) {
    if (this.host === undefined || this.internal === true) {
      return;
    }

    const url = `${this.host}${endpoint}`;
    fetch(url, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify(requestBody),
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },
};

Sq.Shop.Optimizely.init();
